import classNames from 'classnames'
import React, { useContext } from 'react'
import { BookerContext } from '../Booker'
import Field from '../Booker/components/Field'
import FieldContainer from '../Booker/components/FieldContainer'
import FieldButton from '../Booker/components/FieldButton'
import { useIntl } from 'react-intl'

const LoadingField = ({ className, children }: { className?: string; children?: React.ReactNode }) => {
   const { vertical, useTailwindPrefix } = useContext(BookerContext)
   return (
      <FieldContainer
         className={classNames(
            {
               'md:w-4/12': !vertical && !useTailwindPrefix,
               'md:tw-w-4/12': !vertical && useTailwindPrefix,
            },
            className,
         )}
         clipMargin
         noBorder
      >
         {children || (
            <Field>
               <span
                  className={classNames({
                     'text-transparent': !useTailwindPrefix,
                     'tw-text-transparent': useTailwindPrefix,
                  })}
               >
                  _
               </span>
            </Field>
         )}
      </FieldContainer>
   )
}

export const LoadingForm = () => {
   const intl = useIntl()
   const { vertical, useTailwindPrefix, version, inline, showLabels } = useContext(BookerContext)
   return (
      <div
         className={classNames({
            "before:content-[' '] before:table after:block after:content-[''] after:clear-both": !useTailwindPrefix,
            "before:tw-content-[' '] before:tw-table after:tw-block after:tw-content-[''] after:tw-clear-both":
               useTailwindPrefix,
         })}
      >
         <div
            className={classNames({
               'flex flex-col min-w-[250px]': !useTailwindPrefix,
               'tw-flex tw-flex-col tw-min-w-[250px]': useTailwindPrefix,
               'md:flex-row': !vertical && !useTailwindPrefix,
               'md:tw-flex-row': !vertical && useTailwindPrefix,
               'itm-booker-form--padded md:px-widget-pill-padding-x md:py-widget-pill-padding-y md:border-widget-pill-border md:border-widget-pill-border-width md:rounded-widget-pill-border-radius md:bg-widget-pill-background':
                  version === 'padded' && !useTailwindPrefix && !vertical,
               'itm-booker-form--padded md:tw-px-widget-pill-padding-x md:tw-py-widget-pill-padding-y md:tw-border-widget-pill-border md:tw-border-widget-pill-border-width md:tw-rounded-widget-pill-border-radius md:tw-bg-widget-pill-background':
                  version === 'padded' && useTailwindPrefix && !vertical,
               'md:pb-widget-pill-padding-b': version === 'padded' && !vertical && showLabels && !useTailwindPrefix,
               'md:tw-pb-widget-pill-padding-b': version === 'padded' && !vertical && showLabels && useTailwindPrefix,
            })}
         >
            <LoadingField />
            <LoadingField />
            <LoadingField
               className={classNames({
                  'md:hidden text-gray-200': !inline && !useTailwindPrefix,
                  'md:tw-hidden tw-text-gray-200': !inline && useTailwindPrefix,
               })}
               {...(!inline && {
                  children: (
                     <div className="tw-text-[85%] tw-my-3 md:tw-mb-0">
                        {intl.formatMessage({ id: `booker.promotion.question` })}
                     </div>
                  ),
               })}
            />
            <FieldContainer
               className={classNames({
                  'md:w-4/12': !vertical && !useTailwindPrefix,
                  'md:tw-w-4/12': !vertical && useTailwindPrefix,
               })}
               clipMargin
            >
               <FieldButton
                  type="button"
                  className={classNames({
                     'bg-transparent text-transparent border-gray-200': !useTailwindPrefix,
                     'tw-bg-transparent tw-text-transparent tw-border-gray-200': useTailwindPrefix,
                  })}
               >
                  _
               </FieldButton>
            </FieldContainer>
         </div>
      </div>
   )
}
